import React from 'react';

const BitacoraSkeleton = ({ count = 5 }) => (
  <div className="bitacora-skeleton-list">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bitacora-skeleton-item">
        <div className="bitacora-skeleton-line short" />
        <div className="bitacora-skeleton-line medium" />
        <div className="bitacora-skeleton-line long" />
      </div>
    ))}
  </div>
);

export default BitacoraSkeleton;
